import { withErrorHandling } from "@entrilia/shared/api/axiosHelper";
import SpeakerNotesIcon from "@mui/icons-material/SpeakerNotesOutlined";
import { IconButton, Stack, Tooltip, Typography } from "@mui/material";
import adminApi from "../../../api/adminApi";
import type { AssistantChat } from "../../../api/types/assistantTypes";
import AssistantNameEditor from "./AssistantNameEditor";
import { createAssistantNameValidator } from "./assistantNames";

interface Props {
  chat: AssistantChat | undefined;
  isHistoryVisible: boolean;
  onToggleHistory: () => void;
  onRenamed: () => Promise<void>;
}

const chatTitleValidator = createAssistantNameValidator("Chat names");

const renameAssistantChat = withErrorHandling(adminApi.renameAssistantChat);

const ChatTitle = ({ chat, isHistoryVisible, onToggleHistory, onRenamed }: Props) => {
  const handleRename = async (title: string) => {
    if (!chat) {
      return;
    }

    const [, error] = await renameAssistantChat(chat.threadId, { title });
    return error;
  };

  return (
    <Stack direction="row" spacing={1} sx={{ alignItems: "center" }}>
      <Tooltip title={isHistoryVisible ? "Hide chat history" : "Show chat history"}>
        <IconButton
          color={isHistoryVisible ? "primary" : "secondary"}
          onClick={onToggleHistory}
          sx={{ bgcolor: isHistoryVisible ? "action.selected" : undefined }}
        >
          <SpeakerNotesIcon />
        </IconButton>
      </Tooltip>

      {chat && (
        <AssistantNameEditor
          key={chat.threadId}
          name={chat.title || "New chat"}
          validator={chatTitleValidator}
          tooltip="Rename chat"
          placeholder="Enter chat name"
          width="50rem"
          logTag="[ChatTitle] renameAssistantChat"
          onRename={handleRename}
          onRenamed={onRenamed}
        />
      )}

      {!chat && (
        <Typography variant="h6" sx={{ lineHeight: "100%" }}>
          Your Assistant
        </Typography>
      )}
    </Stack>
  );
};

export default ChatTitle;
